export default __webpack_public_path__ + "static/media/fashion-img-banner.ab89e35d.png";